module.exports = __webpack_public_path__ + "static/media/GoTPicker-Logo__desktop.34ff7cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GoTPicker-Logo__desktop.png
// module id = 309
// module chunks = 0